import React from 'react';
import { Box, Card, Text, Heading } from 'pounceV2';
import { FormikSwitchV3 } from 'Components/fields/Switch/SwitchV3';
import { Field, Form, Formik } from 'formik';
import { NotificationPreference } from 'Generated/schema';
import FormikAutosave from 'Components/utils/Autosave';
import { useTheme } from '@mui/material';
import { CHANNELS_NAMES, PREFERENCES_COPIES, validationSchema } from './constants';

export const NotificationsSettingsFormV3 = ({ initialValues, onSubmit }) => {
  const theme = useTheme();
  return (
    <Formik
      enableReinitialize
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <FormikAutosave />
          {initialValues.preferences.map((preference: NotificationPreference, index: number) => {
            return (
              <Card key={preference.topic} as="section" width={1} p={4} mb={4}>
                <Heading variant="h6">{PREFERENCES_COPIES[preference.topic].title}</Heading>
                <Text
                  variant="body/sm"
                  color={theme.palette.tokens.content.text.neutral[3]}
                  mt={3}
                  mb={5}
                >
                  {PREFERENCES_COPIES[preference.topic].description}
                </Text>
                {preference.channels.map((channel, i) => {
                  return (
                    <Box
                      key={`${preference.topic}-${channel.name}`}
                      as="fieldset"
                      fontWeight="medium"
                      sx={{
                        '.MuiFormLabel-root > .MuiTypography-root': {
                          fontSize: theme.palette.typographyTokens.fontSizes.sm,
                        },
                      }}
                    >
                      <Field
                        as={FormikSwitchV3}
                        name={`preferences[${index}].channels[${i}].enabled`}
                        label={CHANNELS_NAMES[channel.name]}
                        disabled={isSubmitting}
                      />
                    </Box>
                  );
                })}
              </Card>
            );
          })}
        </Form>
      )}
    </Formik>
  );
};
